import { Box, styled } from '@mui/material';

export const ImageContainer = styled(Box)(({ theme }) => ({
  backgroundImage: "url('/assets/images/blog/pic_header_blog.jpg')",
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  width: '72.5rem',
  height: '21.125rem',
  marginTop: '2.3125rem',
  marginBottom: '1.75rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  [theme.breakpoints.down('sm')]: {
    backgroundImage: "url('/assets/images/blog/pic_header_blog_responsive.jpg')",
    maxWidth: '90vw',
    height: '360px',
    position: 'relative',
    justifyContent: 'start',
    padding: '2rem 0 0 1rem',
    borderRadius: '1rem',
    backgroundPositionX: 'right',
    backgroundPositionY: 'bottom',
    margin: '1.8rem auto 1.25rem',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: '95vw',
    height: '338px',
    backgroundPositionX: 'right',
    borderRadius: '1rem',
  },
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  marginLeft: '1.8125rem',
  position: 'absolute',
}));
